if (!customElements.get('details-accordion')) {
  customElements.define(
    'details-accordion',
    class extends HTMLElement {
      constructor() {
        super();
        this.animation = null;
        this.isClosing = false;
        this.isExpanding = false;
      }

      connectedCallback() {
        this.details = this.querySelector('details');
        this.summary = this.querySelector('summary');
        this.content = this.querySelector('.accordion__content');

        if (this.summary) {
          this.onSummaryClick = (e) => this.onClick(e);
          this.summary.addEventListener('click', this.onSummaryClick);
        }
      }

      disconnectedCallback() {
        if (this.summary && this.onSummaryClick) {
          this.summary.removeEventListener('click', this.onSummaryClick);
        }
      }

      onClick(e) {
        e.preventDefault();
        this.details.style.overflow = 'hidden';

        if (this.isClosing || !this.details.open) {
          this.open();
        } else if (this.isExpanding || this.details.open) {
          this.shrink();
        }
      }

      shrink() {
        this.isClosing = true;
        const startHeight = `${this.details.offsetHeight}px`;
        const endHeight = `${this.summary.offsetHeight}px`;

        if (this.animation) this.animation.cancel();

        this.animation = this.details.animate(
          {
            height: [startHeight, endHeight],
          },
          {
            duration: 200,
            easing: 'ease-out',
          }
        );

        this.animation.onfinish = () => this.onAnimationFinish(false);
        this.animation.oncancel = () => (this.isClosing = false);
      }

      open() {
        this.details.style.height = `${this.details.offsetHeight}px`;
        this.details.open = true;
        window.requestAnimationFrame(() => this.expand());
      }

      expand() {
        this.isExpanding = true;
        const startHeight = `${this.details.offsetHeight}px`;
        const endHeight = `${this.summary.offsetHeight + this.content.offsetHeight}px`;

        if (this.animation) this.animation.cancel();

        this.animation = this.details.animate(
          {
            height: [startHeight, endHeight],
          },
          {
            duration: 300,
            easing: 'ease-out',
          }
        );

        this.animation.onfinish = () => this.onAnimationFinish(true);
        this.animation.oncancel = () => (this.isExpanding = false);
      }

      onAnimationFinish(open) {
        this.details.open = open;
        this.animation = null;
        this.isClosing = false;
        this.isExpanding = false;
        this.details.style.height = '';
        this.details.style.overflow = '';
      }
    }
  );
}
